// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"31d6cfe0","976":"08069582"}[chunkId] + ".chunk.css";
};